import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Close as CloseIcon } from "@mui/icons-material";
import { AiOutlineInfoCircle } from "react-icons/ai";
import Tooltip from "@mui/material/Tooltip";

import "../pubvision/AssetsGeneration.css";
import PropTypes from "prop-types";

const PosterDialog = ({
  open,
  onClose,
  posterSections,
  setPosterSections,
  posterLanguage,
  setPosterLanguage,
  addReferences,
  setAddReferences,
  posterContentLevel,
  setPosterContentLevel,
  posterSelectedColor,
  setPosterSelectedColor,
  posterCustomColor,
  setPosterCustomColor,
  onStartGeneratingPoster,
}) => {

  const levels = [
    "Physicians",
    "Medical Affairs",
    "Clinical Development",
    "Commercial Teams",
    "Market Access & HEOR",
    "Regulatory & Safety",
    "KOLs / Researchers",
    "Executives",
    "Patients"
  ];

  const levelDescriptions = {
    "Physicians": "Frontline clinicians focused on patient care, diagnosis, treatment decisions, and clinical outcomes.",
    "Medical Affairs": "Bridge between clinical data and the medical community — managing publications, advisory boards, and scientific exchange.",
    "Clinical Development": "Designs and runs clinical trials to evaluate safety, efficacy, and dosing of new therapies.",
    "Commercial Teams": "Drive product adoption through sales strategy, marketing, and customer engagement with healthcare providers.",
    "Market Access & HEOR": "Secure payer coverage and demonstrate value through health economics, outcomes research, and reimbursement strategy.",
    "Regulatory & Safety": "Ensure compliance with regulatory requirements, manage drug safety reporting, and oversee pharmacovigilance.",
    "KOLs / Researchers": "Academic leaders and researchers who shape clinical practice through publications, guidelines, and thought leadership.",
    "Executives": "Senior leadership driving corporate strategy, pipeline decisions, and organizational priorities.",
    "Patients": "Individuals receiving medical care, seeking to understand disease states, treatments, and clinical outcomes."
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="abstract-video-dialog"
      sx={{
        "& .MuiBackdrop-root": { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        "& .MuiPaper-root": { fontFamily: "'Inter', sans-serif" },
        "& *": { fontFamily: "'Inter', sans-serif !important" },
      }}
    >
      <DialogTitle className="dialog-title">
        <IconButton aria-label="close" onClick={onClose} className="close-button" size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogTitle className="dialog-title main-title">
        <strong>Poster : Enter requirements below</strong>
      </DialogTitle>
      <div className="dialog-subtitle-container">
        <p className="dialog-subtitle">
          Please fill the form below to get the poster as per your requirement
        </p>
      </div>
      <DialogContent className="dialog-content">
        {/* Content Understanding Level */}
        <div className="dialog-field">
          <FormControl component="fieldset">
            <FormLabel component="legend" className="dialog-label" focused={false}>
              Choose Poster Content Understanding Level
            </FormLabel>
            <Select
              value={posterContentLevel}
              onChange={(e) => setPosterContentLevel(e.target.value)}
              displayEmpty
              className="level-options"
              style={{ marginTop: "12px", width: "100%" }}
            >
              {levels.map((level) => (
                <MenuItem key={level} value={level} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>{level}</span>
                  <Tooltip
                    title={levelDescriptions[level]}
                    arrow
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#fff",
                          color: "#1E4DE3",
                          fontSize: "13px",
                          lineHeight: "1.5",
                          padding: "10px 14px",
                          maxWidth: "350px",
                          border: "1px solid #1E4DE3",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          "& .MuiTooltip-arrow": {
                            color: "#fff",
                            "&::before": {
                              border: "1px solid #1E4DE3"
                            }
                          }
                        }
                      }
                    }}
                  >
                    <IconButton
                      size="small"
                      style={{
                        padding: "4px",
                        color: "#9ca3af",
                        transition: "all 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    >
                      <AiOutlineInfoCircle size={16} />
                    </IconButton>
                  </Tooltip>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Credits Required Display */}
        <div style={{
          marginTop: "16px",
          fontSize: "14px",
          color: "#1E4DE3",
        }}>
          Credits required: <strong>2</strong>
        </div>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} variant="text" className="cancel-btn">
          Cancel
        </Button>
        <Button onClick={onStartGeneratingPoster} variant="contained" className="start-generating-btn">
          Start Generating
        </Button>
      </DialogActions>
    </Dialog>
  );
};
PosterDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  posterSections: PropTypes.object.isRequired,
  setPosterSections: PropTypes.func.isRequired,
  posterLanguage: PropTypes.string.isRequired,
  setPosterLanguage: PropTypes.func.isRequired,
  addReferences: PropTypes.string.isRequired,
  setAddReferences: PropTypes.func.isRequired,
  posterContentLevel: PropTypes.string.isRequired,
  setPosterContentLevel: PropTypes.func.isRequired,
  posterSelectedColor: PropTypes.string.isRequired,
  setPosterSelectedColor: PropTypes.func.isRequired,
  posterCustomColor: PropTypes.string.isRequired,
  setPosterCustomColor: PropTypes.func.isRequired,
  onStartGeneratingPoster: PropTypes.func.isRequired,
};

export default PosterDialog;
